<template>
  <a-modal
    :title="!dataForm.id ? '新增' : '修改'"
    :close-on-click-modal="false"
    :visible.sync="visible"
    width="700px"
    @cancel="handleCancel"
    @ok="handleOk"
  >
    <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
      <a-form-item label="规则名称">
        <a-input
          maxLength="10"
          v-decorator="[
            'ruleName',
            { rules: [{ required: true, message: '请输入规则名称!' }] }
          ]"
        />
      </a-form-item>
      <a-form-item label="匹配词">
        <template v-for="(tag, index) in dataForm.matchValue">
          <a-tooltip v-if="tag.length > 20" :key="tag" :title="tag">
            <a-tag
              :key="tag"
              :closable="index >= 0"
              @close="() => handleClose(tag)"
            >
              {{ `${tag.slice(0, 20)}...` }}
            </a-tag>
          </a-tooltip>
          <a-tag
            v-else
            :key="tag"
            :closable="index >= 0"
            @close="() => handleClose(tag)"
          >
            {{ tag }}
          </a-tag>
        </template>
        <a-input
          v-if="inputVisible"
          ref="input"
          type="text"
          size="small"
          :style="{ width: '78px' }"
          v-decorator="[
            'inputValue',
            { rules: [{ required: true, message: '请输入匹配词!' }] }
          ]"
          @change="handleInputChange"
          @blur="handleInputConfirm"
          @keyup.enter="handleInputConfirm"
        />
        <a-tag v-else color="blue" @click="showInput">
          <a-icon type="plus" /> 添加
        </a-tag>
      </a-form-item>
      <a-form-item label="作用范围">
        <a-select v-decorator="['appid']" placeholder="作用范围">
          <a-select-option value="" v-if="this.dataForm.replyType === 'text'"
            >全部公众号</a-select-option
          >
          <a-select-option :value="this.wechatAppId" v-if="!!this.wechatAppId"
            >当前公众号</a-select-option
          >
        </a-select>
      </a-form-item>
      <a-form-item label="精确匹配">
        <a-switch
          v-decorator="['exactMatch']"
          :checked-children="true"
          :un-checked-children="false"
        ></a-switch>
      </a-form-item>
      <a-form-item label="回复类型">
        <a-select
          v-decorator="[
            'replyType',
            { rules: [{ required: true, message: '请选择回复类型!' }] }
          ]"
          @change="onReplyTypeChange"
        >
          <a-select-option
            v-for="(name, key) in KefuMsgType"
            :key="key"
            :value="key"
            >{{ name }}</a-select-option
          >
        </a-select>
      </a-form-item>
      <a-form-item label="是否启用">
        <a-switch
          v-decorator="['status']"
          :checked-children="true"
          :un-checked-children="false"
        ></a-switch>
      </a-form-item>
      <a-form-item label="生效时间">
        <a-time-picker
          v-decorator="[
            'effectTimeStart',
            { rules: [{ required: true, message: '请选择生效时间!' }] }
          ]"
          format="HH:mm:ss"
          @change="timeStartChange"
        ></a-time-picker>
      </a-form-item>
      <a-form-item label="失效时间">
        <a-time-picker
          v-decorator="[
            'effectTimeEnd',
            { rules: [{ required: true, message: '请选择失效时间!' }] }
          ]"
          format="HH:mm:ss"
          @change="timeEndChange"
        ></a-time-picker>
      </a-form-item>
      <a-form-item label="回复内容">
        <a-input
          v-decorator="[
            'replyContent',
            { rules: [{ required: true, message: '请选择回复内容!' }] }
          ]"
          type="textarea"
          :rows="5"
          placeholder="文本、图文ID、media_id、json配置"
        ></a-input>
        <a-button
          type="text"
          v-show="'text' == dataForm.replyType"
          @click="addLink"
          >插入链接</a-button
        >
        <a-button
          type="text"
          v-show="assetsType"
          @click="assetsSelectorVisible = true"
        >
          从素材库中选择<span
            v-if="
              'miniprogrampage' == dataForm.replyType ||
                'music' == dataForm.replyType
            "
            >缩略图</span
          >
        </a-button>
      </a-form-item>
      <a-form-item label="备注说明">
        <a-input v-decorator="['remarks']" placeholder="备注说明"></a-input>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { mapState } from 'vuex';
import pick from 'lodash.pick';
import moment from 'moment';
import { getAction, httpAction, postAction, postTag } from '@/api/manage';
export default {
  props: {
    wechatAppId: {
      type: String,
      required: true
    }
  },
  components: {
    // AssetsSelector: () => import('./assets/assets-selector')
  },
  data() {
    return {
      dataForm: {
        replyType: 'text'
      },
      form: this.$form.createForm(this, { name: 'coordinated' }),
      visible: false,
      assetsSelectorVisible: false,
      tags: [],
      inputVisible: false,
      inputValue: '',
      id: '',
      KefuMsgType: {
        text: '文本消息',
        image: '图片消息',
        voice: '语音消息',
        video: '视频消息',
        music: '音乐消息',
        news: '文章链接',
        mpnews: '公众号图文消息',
        wxcard: '卡券消息',
        miniprogrampage: '小程序消息',
        msgmenu: '菜单消息'
      }
    };
  },
  computed: mapState({
    //selectedAppid:state=>state.wxAccount.selectedAppid,
    assetsType() {
      const config = {
        //消息类型与选择素材类型对应关系
        image: 'image',
        voice: 'voice',
        video: 'video',
        mpnews: 'news',
        miniprogrampage: 'image', //小程序需选择卡片图
        music: 'image'
      };
      return config[this.dataForm.replyType] || '';
    }
  }),
  methods: {
    moment,
    timeStartChange(timeString) {
      this.dataForm.effectTimeStart = timeString;
    },
    timeEndChange(timeString) {
      this.dataForm.effectTimeEnd = timeString;
    },
    handleClose(removedTag) {
      const tags = this.tags.filter(tag => tag !== removedTag);
      this.tags = tags;
      this.dataForm.matchValue = tags;
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(function() {
        this.$refs.input.focus();
      });
    },
    handleInputChange(e) {
      this.inputValue = e.target.value;
    },
    handleInputConfirm() {
      const inputValue = this.inputValue;
      let tags = this.dataForm.matchValue;
      if (inputValue && tags.indexOf(inputValue) === -1) {
        tags = [...tags, inputValue];
      }
      console.log(tags);
      Object.assign(this, {
        tags,
        inputVisible: false,
        inputValue: ''
      });
      this.dataForm.matchValue = tags;
    },
    handleOk(e) {
      this.dataFormSubmit();
    },
    handleCancel(e) {
      this.visible = false;
      this.form.resetFields();

      this.dataForm.effectTimeStart = moment('00:00:00', 'HH:mm:ss');
      this.dataForm.effectTimeEnd = moment('23:59:59', 'HH:mm:ss');
    },
    init(id) {
      this.visible = true;
      this.dataForm.id = id || '';

      console.warn(!id);
      if (!id) {
        this.form.resetFields();
        this.dataForm.matchValue = '';

        this.$nextTick(() => {
          this.form.setFieldsValue({
            effectTimeStart: moment('00:00:00', 'HH:mm:ss'),
            effectTimeEnd: moment('23:59:59', 'HH:mm:ss'),
            replyType: 'text'
          });
        });
        return;
      }

      this.$nextTick(() => {
        if (this.dataForm.id) {
          getAction(
            process.env.VUE_APP_CMS_WECHAT +
              `/manage/msgReplyRule/info/${this.dataForm.id}`
          ).then(res => {
            if (res.success) {
              // this.dataForm = res.result;
              res.result.effectTimeStart = moment(
                res.result.effectTimeStart,
                'HH:mm'
              );
              res.result.effectTimeEnd = moment(
                res.result.effectTimeEnd,
                'HH:mm'
              );
              this.dataForm.matchValue = res.result.matchValue.split(',');
              this.model = Object.assign({}, res.result);
              this.dataForm.replyType = res.result.replyType;

              this.id = res.result.id;
              this.form.setFieldsValue(
                pick(
                  this.model,
                  'appid',
                  'ruleName',
                  'matchValue',
                  'status',
                  'exactMatch',
                  'effectTimeEnd',
                  'effectTimeStart',
                  'replyContent',
                  'replyType',
                  'remarks'
                )
              );
            }
          });
        }
      });
    },
    // 表单提交
    dataFormSubmit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          // let formData = Object.assign(values);
          console.warn(values);
          values.effectTimeStart = moment(values.effectTimeStart).format(
            'HH:mm:ss'
          );
          values.effectTimeEnd = moment(values.effectTimeEnd).format(
            'HH:mm:ss'
          );
          console.warn(values.matchValue);
          if (values.matchValue) {
            values.matchValue = this.dataForm.matchValue.join(',');
          }
          values.id = this.id;
          postTag(
            process.env.VUE_APP_CMS_WECHAT +
              `/manage/msgReplyRule/${!this.id ? 'save' : 'update'}`,
            values
          ).then(res => {
            if (res.success) {
              this.$message.success('操作成功');
              this.visible = false;
              this.$emit('refreshDataList');
            } else {
              this.$message.error(res.message);
            }
          });
        }
      });
    },
    addLink() {
      this.form.setFieldsValue({
        replyContent: '<a href="链接地址">链接文字</a>'
      });
      this.dataForm.replyContent += '<a href="链接地址">链接文字</a>';
    },
    onReplyTypeChange(value) {
      console.warn(value);
      this.dataForm.replyType = value;
      if ('miniprogrampage' == value) {
        let demo = {
          title: '标题',
          appid: '小程序APPID',
          pagepath: '页面地址',
          thumb_media_id: '缩略图media_id'
        };
        this.setFieldsValue({
          replyContent: JSON.stringify(demo, null, 4)
        });
        this.dataForm.replyContent = JSON.stringify(demo, null, 4);
      } else if ('music' == value) {
        let demo = {
          musicurl: '音乐链接',
          hqmusicurl: '高品质链接',
          title: '标题',
          description: '描述',
          thumb_media_id: '缩略图media_id'
        };
        this.form.setFieldsValue({
          replyContent: JSON.stringify(demo, null, 4)
        });
        this.dataForm.replyContent = JSON.stringify(demo, null, 4);
      } else if ('msgmenu' == value) {
        let demo = {
          head_content: '开头文字',
          list: [
            { id: '菜单1ID', content: '菜单2内容' },
            { id: '菜单2ID', content: '菜单2内容' },
            { id: '菜单nID', content: '菜单n内容' }
          ],
          tail_content: '结尾文字'
        };
        this.form.setFieldsValue({
          replyContent: JSON.stringify(demo, null, 4)
        });
        this.dataForm.replyContent = JSON.stringify(demo, null, 4);
      } else if ('news' == value) {
        let demo = {
          title: '文章标题',
          description: '文章简介',
          url: '链接URL',
          picUrl: '缩略图URL'
        };
        this.form.setFieldsValue({
          replyContent: JSON.stringify(demo, null, 4)
        });
        this.dataForm.replyContent = JSON.stringify(demo, null, 4);
      } else {
        this.form.setFieldsValue({
          replyContent: '媒体素材media_id'
        });
        this.dataForm.replyContent = '媒体素材media_id';
      }
    },
    onAssetsSelect(assetsInfo) {
      if (
        this.dataForm.replyType == 'miniprogrampage' ||
        this.dataForm.replyType == 'music'
      ) {
        let data = JSON.parse(this.dataForm.replyContent);
        if (data && data.thumb_media_id)
          data.thumb_media_id = assetsInfo.mediaId;
        this.dataForm.replyContent = JSON.stringify(data, null, 4);
      } else {
        this.dataForm.replyContent = assetsInfo.mediaId;
      }
      this.assetsSelectorVisible = false;
    }
  }
};
</script>
<style scoped>
/deep/ .ant-modal-body {
  height: 600px;
  overflow: scroll;
}
</style>
